module.exports = __webpack_public_path__ + "static/media/DavidA.65be3334.jpg";